import { connect } from 'react-redux'
import { ServiceViewMember } from '../../components/services/view/ServiceViewMember'
import { IStoreState, IRiderFilters } from '../../types/index'
import { getMany } from '../../state/actions/riders'
import { getRidersList } from '../../state/reducers/riders'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    steps: state.serviceEdit.steps.list,
    routeProps: ownProps.routeProps,
    serviceId: ownProps.serviceId,
    members: getRidersList(state.riders),
    totalItems: state.riders.metadata.total
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMembers: (filters: IRiderFilters) => {
      return dispatch(getMany(filters))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewMember)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewMember.ts